import anime from 'animejs';
import lottie from 'lottie-web';

window.app = {

    resourcePath: '/wp-content/themes/bare-metal-child/resources',

    submenu: {
        business: 0,
        personal: 0
    },

    menu: false,

    init() {

        this.menuToggle();

        $('body').on('click', '.business', $.proxy(this.slideBusiness, this));
        $('body').on('click', '.private', $.proxy(this.slidePrivate, this));

        $('body').on('click', '#close-icon', (e) => {
            $('body').toggleClass('no-scroll');
            if (app.menu === false ? app.menu = true : app.menu = false);
            $('.mobile__nav').slideToggle();
            if (app.menu === false ? toggle.playSegments([14, 27] ) : toggle.playSegments([0, 14]));
        });

        $('body').on('click', '.submenu__toggle', (e) => {
            const parent = $(e.currentTarget).parent();
            parent.find('.submenu').slideToggle();
        });
        return this;
    },

    slideBusiness(e) {
        e.preventDefault();

        if (app.submenu.business == 0) {
            app.slideAnim('.sub__menu--business');
            app.slideAnimReverse('.sub__menu--personal');
            app.submenu.business = 1;
            app.submenu.personal = 0;
        } else {
            app.slideAnimReverse('.sub__menu--business');
            app.submenu.business = 0;
        }
    },

    slidePrivate(e) {
        e.preventDefault();
        if (app.submenu.personal == 0) {
            app.slideAnim('.sub__menu--personal');
            app.slideAnimReverse('.sub__menu--business');
            app.submenu.personal = 1;
            app.submenu.business = 0;
        } else {
            app.slideAnimReverse('.sub__menu--personal');
            app.submenu.personal = 0;
        }
    },

    slideAnim(target) {
        anime({
          targets: target,
          translateX: 300,
          easing: 'easeOutQuad',
          duration: 500
        });
    },

    slideAnimReverse(target) {
        anime({
          targets: target,
          translateX: 0,
           easing: 'easeOutQuad',
           duration: 500
        });
    },

    menuToggle(e) {



    $('body').on('click', '.has-children', (e) => {
        $(e.currentTarget).children('.ul-child').toggle();
    });
},
}

$(document).ready($.proxy(app.init, app));

var params3 = {
    container: document.getElementById('close-icon'),
    renderer: 'svg',
    loop: false,
    autoplay: false,
    path:  `${app.resourcePath}/animations/close-icon.json`,

};

var toggle;

toggle = lottie.loadAnimation(params3);
